import { render, staticRenderFns } from "./child_content.vue?vue&type=template&id=51feae1f"
import script from "./child_content.vue?vue&type=script&lang=js"
export * from "./child_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports